// extracted by mini-css-extract-plugin
export var consentPage = "styles-module--consent-page--4x50z";
export var container = "styles-module--container--A2jFI";
export var iconLogo = "styles-module--icon-logo---xO5c";
export var questionItem = "styles-module--question-item--fVTx8";
export var root = "styles-module--root--UdsZN";